import { render, staticRenderFns } from "./TrainIndex.vue?vue&type=template&id=8e1db4be&scoped=true"
import script from "./TrainIndex.vue?vue&type=script&lang=js"
export * from "./TrainIndex.vue?vue&type=script&lang=js"
import style0 from "./TrainIndex.vue?vue&type=style&index=0&id=8e1db4be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1db4be",
  null
  
)

export default component.exports